const REF_PATTERN = /^(.+?)<([^<>]+)>$/; // e.g. 'Labeled Download <file.zip>'
export const downloadRole = {
    name: 'download',
    body: {
        type: String,
        required: true,
    },
    run(data) {
        const body = data.body;
        const match = REF_PATTERN.exec(body);
        const [, modified, rawLabel] = match !== null && match !== void 0 ? match : [];
        const url = rawLabel !== null && rawLabel !== void 0 ? rawLabel : body;
        const link = {
            type: 'link',
            url,
            static: true, // Indicate that this should be treated as a static download
        };
        if (modified)
            link.children = [{ type: 'text', value: modified.trim() }];
        return [link];
    },
};
